export type OnboardingStepId =
  | "profile"
  | "platforms"
  | "connect-linkedin"
  | "connect-google"
  | "book-google-call"
  | "connect-meta"
  | "slack"
  | "done";

export type AdPlatform = "linkedin" | "google" | "meta";

export interface OnboardingAnswers {
  "first-name"?: string;
  "last-name"?: string;
  email?: string;
  company?: string;
  title?: string;
  platforms?: AdPlatform[];
  "linkedin-connected"?: boolean;
  "google-ads-connected"?: boolean;
  "google-call-booked"?: boolean;
  "meta-connected"?: boolean;
  "slack-connected"?: boolean;
}

export interface OnboardingStep {
  id: OnboardingStepId;
  title: string;
  skippable: boolean;
  showIf: (answers: OnboardingAnswers) => boolean;
}

const hasPlatform = (answers: OnboardingAnswers, p: AdPlatform) =>
  Boolean(answers.platforms?.includes(p));

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: "profile",
    title: "Tell us about yourself",
    skippable: false,
    showIf: () => true,
  },
  {
    id: "platforms",
    title: "Which ad platforms do you use?",
    skippable: false,
    showIf: () => true,
  },
  {
    id: "connect-linkedin",
    title: "Connect your LinkedIn Ads account",
    skippable: false,
    showIf: (answers) => hasPlatform(answers, "linkedin"),
  },
  {
    id: "connect-google",
    title: "Connect your Google Ads account",
    skippable: false,
    showIf: (answers) => hasPlatform(answers, "google"),
  },
  {
    id: "book-google-call",
    title: "Book your Google Ads onboarding call",
    skippable: false,
    showIf: (answers) => hasPlatform(answers, "google"),
  },
  {
    id: "connect-meta",
    title: "Connect your Meta ad account",
    skippable: false,
    showIf: (answers) => hasPlatform(answers, "meta"),
  },
  {
    id: "slack",
    title: "Connect Slack for support",
    skippable: true,
    showIf: () => true,
  },
  {
    id: "done",
    title: "You're all set",
    skippable: false,
    showIf: () => true,
  },
];

export const visibleSteps = (answers: OnboardingAnswers): OnboardingStep[] =>
  ONBOARDING_STEPS.filter((s) => s.showIf(answers));
